export default __webpack_public_path__ + "static/media/api.c4260099.png";